(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["restaurant-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.rm-container');
    const tabButtons = container.querySelectorAll('.rm-tab-button');
    const tabPanels = container.querySelectorAll('.rm-tab-panel');

    function switchTab(event) {
      const clickedButton = event.currentTarget;
      const targetHandle = clickedButton.getAttribute('data-target');
      
      // Deactivate all
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));

      // Activate clicked
      clickedButton.classList.add('active');
      const targetPanel = container.querySelector(`#${targetHandle}`);
      if(targetPanel) {
        targetPanel.classList.add('active');
      }
    }

    tabButtons.forEach(button => {
      button.addEventListener('click', switchTab);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
